/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_1_QInputs */

const en_mk_tut_tr_1_q = /** @type {(inputs: Mk_Tut_Tr_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I assigned an agent and nothing happened.`)
};

const id_mk_tut_tr_1_q = /** @type {(inputs: Mk_Tut_Tr_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya menugaskan agen, tapi tidak terjadi apa-apa.`)
};

/**
* | output |
* | --- |
* | "I assigned an agent and nothing happened." |
*
* @param {Mk_Tut_Tr_1_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_1_q = /** @type {((inputs?: Mk_Tut_Tr_1_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_1_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_1_q(inputs)
	return en_mk_tut_tr_1_q(inputs)
});